import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/public/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || "Beitrag nicht gefunden"))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <section data-testid="blog-post-page" className="relative z-10 bg-[#0a0a0a] py-24 lg:py-36 border-t border-white/10 min-h-[70vh]">
      {post && <Seo title={`G-Repair — ${post.title}`} description={post.excerpt || post.title} />}
      <div className="max-w-2xl mx-auto px-6 lg:px-10">
        <Link to="/ratgeber" data-testid="blog-post-back" className="inline-flex items-center gap-1.5 text-sm text-[#888] hover:text-white transition-colors mb-8">
          <ArrowLeft size={15} /> Zurück zum Ratgeber
        </Link>

        {loading && <p className="text-[#888] font-mono text-sm">Lädt…</p>}
        {!loading && error && <p data-testid="blog-post-error" className="text-red-400 text-sm">{error}</p>}

        {!loading && post && (
          <article data-testid="blog-post-content">
            {post.cover_image_url && (
              <img src={post.cover_image_url} alt={post.title} className="w-full aspect-[16/9] object-cover rounded-3xl mb-8" />
            )}
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#888] mb-4">
              {new Date(post.created_at).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" })}
            </p>
            <h1 className="font-display text-white text-4xl sm:text-5xl leading-[0.98] mb-8">{post.title}</h1>
            <div className="text-[#ccc] leading-relaxed space-y-4">
              {post.content.split(/\n\s*\n/).map((para, i) => (
                <p key={i} data-testid={`blog-paragraph-${i}`}>{para}</p>
              ))}
            </div>
          </article>
        )}
      </div>
    </section>
  );
}
